var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCampus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 8",
    transform: "translate(2.085 -0.43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 78",
    d: "M35.338,17.651H26.5V4.332L30.919.692l4.419,3.64Z",
    transform: "translate(-21.004 2.738)",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 79",
    d: "M5.5,39.572H.5v4.1h5",
    transform: "translate(0 -30.482)",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 80",
    d: "M72.5,43.672h5v-4.1h-5",
    transform: "translate(-58.166 -30.481)",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 81",
    d: "M.5,77.033v5.028h5",
    transform: "translate(0 -61.673)",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 82",
    d: "M72.5,82.062h5V77.033",
    transform: "translate(-58.166 -61.673)",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Linea 2",
    y2: 5.874,
    transform: "translate(9.915 14.515)",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Linea 3",
    y2: 2,
    transform: "translate(9.915 9.091)",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Linea 4",
    y2: 1.563,
    transform: "translate(2.998 15.888)",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Linea 5",
    y2: 1.563,
    transform: "translate(16.832 15.888)",
    fill: "none",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampus);
export default __webpack_public_path__ + "static/media/icon_campus.fe29cafd608657ca21aa3cea94316aed.svg";
export { ForwardRef as ReactComponent };